import * as React from 'react';

import { useReadAloud } from '../readAloud/readAloudContext';
import { ReadAloudSection } from '../readAloud/readAloudSection';

const beginBold = '<span class="sr-only">(begin bold) </span>'
const endBold = '<span class="sr-only"> (end bold)</span>'

const SentenceFragments = ({ prompt, }) => {
  const { readAloudEnabled, } = useReadAloud()
  if (readAloudEnabled) { return <ReadAloudSection annotateBold={true} className="draft-js sentence-fragments" html={prompt} label="Read the sentences aloud" /> }

  const promptAnnotatedForScreenreader = prompt.replace(/<strong>/g, `${beginBold}<strong>`).replace(/<\/strong>/g, `</strong>${endBold}`)
  return <div className="draft-js sentence-fragments" dangerouslySetInnerHTML={{ __html: promptAnnotatedForScreenreader, }} />
}

export { SentenceFragments };
